import React, { Component } from 'react'
import { connect } from 'react-redux'
import { UserCreate as UserCreate24 } from 'projects/flow-gui-access/views/2.4/users'

class UserCreate extends Component {

  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'users').length !== 0) {
      return <UserCreate24 {...this.props} />
    } else {
      return null
    }
  }
}

UserCreate = connect(state => state)(UserCreate)
export default UserCreate



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/users/create.js